(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class KsRecentlyViewed extends HTMLElement {
    constructor () {
      super()

      this.recentlyViewed = JSON.parse(localStorage.getItem('ks-recently-viewed')) || []

      if (this.recentlyViewed.length) {
        this.setProductList()
        this.querySelector('#product-grid').removeAttribute('hidden')        
      } else {
        this.querySelector('#ks-recently-viewed-empty').removeAttribute('hidden')
      }
    }

    setProductList () {
      let productList = ''

      let imgWidth, imgHeight

      switch (this.dataset.imageRatio) {
      case 'square':
        imgWidth = 600
        imgHeight = 600
        break
      case 'landscape':
        imgWidth = 600
        imgHeight = 480
        break
      case 'portrait':
        imgWidth = 480
        imgHeight = 600
        break
      }
      
      this.recentlyViewed.reverse().forEach((product, index) => {
        productList += `
          <li 
            class="grid__item scroll-trigger animate--slide-in" 
            data-cascade
            style="--animation-order: ${index + 1};">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <a href="${product.url}" class="full-unstyled-link"> 
                <img 
                  src="${this.resizeImage(product.img_src, `${imgWidth}x${imgHeight}`, 'center')}"
                  class="img-fluid ${this.dataset.imgBorder}" 
                  alt="${product.img_alt}" 
                  width="${imgWidth}" 
                  height="${imgHeight}" 
                  loading="lazy">
                <h3 class="card__heading h5">
                  ${product.title}
                </h3>
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular" ${product.compare_at_price > product.price ? '' : 'hidden'}>
                      <span class="visually-hidden visually-hidden--inline">
                        Regular price
                      </span>
                      <span class="price-item price-item--regular">
                        ${this.formatMoney(product.price)}
                      </span>
                    </div>
                    <div class="price__sale" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                      <span class="visually-hidden visually-hidden--inline">
                        Regular price
                      </span>
                      <span>
                        <s class="price-item price-item--regular">
                          ${this.formatMoney(product.compare_at_price)}
                        </s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">
                        Sale price
                      </span>
                      <span class="price-item price-item--sale price-item--last">
                        ${this.formatMoney(product.price)}
                      </span>
                    </div>
                  </div>
                </div>
              </a>
              <p class="product-added-at d-flex align-items-center small opacity-75 mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                ${this.calcTimeAgo(product.added_at)}
              </p>
            </div>
          </li>
        `
      })

      this.querySelector('#product-grid').innerHTML = productList
    }

    formatMoney (cents, moneyFormat = this.dataset.moneyFormat) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }

    resizeImage = function (src, size, crop = '') {
      return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          if (crop.length) {
            crop = `_crop_${crop}`
          }
          return `_${size}${crop}${match}`
        })
    }

    calcTimeAgo (timestamp) {
      const now = new Date().getTime()
      const diff = now - timestamp

      let text

      if (diff < 60000) {
        text = this.dataset.textTimesMoments
      } else if (diff < 3.6e+6) {
        const min = Math.round((diff) / 60000)
        text = min === 1
          ? `${min} ${this.dataset.textMinute}`
          : `${min} ${this.dataset.textTimesMinutes}`
      } else if (diff < 8.64e+7) {
        const hours = Math.round((diff) / 3.6e+6)
        text = hours === 1
          ? `${hours} ${this.dataset.textTimesHour}`
          : `${hours} ${this.dataset.textTimesHours}`
      } else {
        const days = Math.round((diff) / 8.64e+7)
        text = days === 1
          ? `${days} ${this.dataset.textTimesDay}`
          : `${days} ${this.dataset.textTimesDays}`
      }

      return `${text} ${this.dataset.textTimesAgo}`
    }
  }

customElements.define('ks-recently-viewed', KsRecentlyViewed)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
